/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_NoteInputs */

const tr_iletisim_s6_note = /** @type {(inputs: Iletisim_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ platformu Emonse® E-Ticaret Limited Şirketi tarafından işletilmektedir. Veri sorumlusu sıfatıyla kişisel veri işleme faaliyetleri Emonse® tarafından yürütülür.`)
};

const en_iletisim_s6_note = /** @type {(inputs: Iletisim_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ShopPanel™ platform is operated by Emonse® E-Ticaret Limited Şirketi. Personal data processing activities are carried out by Emonse® in its capacity as data controller.`)
};

const de_iletisim_s6_note = /** @type {(inputs: Iletisim_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform ShopPanel™ wird von der Emonse® E-Ticaret Limited Şirketi betrieben. Die Verarbeitung personenbezogener Daten erfolgt durch Emonse® in der Eigenschaft als verantwortliche Stelle.`)
};

const ru_iletisim_s6_note = /** @type {(inputs: Iletisim_S6_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа ShopPanel™ управляется компанией Emonse® E-Ticaret Limited Şirketi. Обработка персональных данных осуществляется компанией Emonse® в качестве оператора персональных данных.`)
};

/**
* | output |
* | --- |
* | "The ShopPanel™ platform is operated by Emonse® E-Ticaret Limited Şirketi. Personal data processing activities are carried out by Emonse® in its capacity as d..." |
*
* @param {Iletisim_S6_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_note = /** @type {((inputs?: Iletisim_S6_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_note(inputs)
	if (locale === "de") return de_iletisim_s6_note(inputs)
	if (locale === "ru") return ru_iletisim_s6_note(inputs)
	return tr_iletisim_s6_note(inputs)
});